
export default function TuneIcon({ width = "15px", stroke }) {
  return (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 3.66699H11.5M11.5 3.66699C11.5 5.04771 12.6192 6.16699 14 6.16699C15.3807 6.16699 16.5 5.0477 16.5 3.66699C16.5 2.28628 15.3807 1.16699 14 1.16699C12.6192 1.16699 11.5 2.28628 11.5 3.66699ZM6.5 10.3337H16.5M6.5 10.3337C6.5 11.7144 5.38071 12.8337 4 12.8337C2.61929 12.8337 1.5 11.7144 1.5 10.3337C1.5 8.95291 2.61929 7.83366 4 7.83366C5.38071 7.83366 6.5 8.95291 6.5 10.3337Z" stroke="#2A93DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}